import { render } from "./FormCheckbox.vue?vue&type=template&id=68c52434"
import script from "./FormCheckbox.vue?vue&type=script&setup=true&lang=js"
export * from "./FormCheckbox.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Sources/JavaScript/Extensions/Lfmpublications/Vue/components/FormCheckbox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "68c52434"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('68c52434', __exports__)) {
    api.reload('68c52434', __exports__)
  }
  
  module.hot.accept("./FormCheckbox.vue?vue&type=template&id=68c52434", () => {
    api.rerender('68c52434', render)
  })

}


export default __exports__